import { render, staticRenderFns } from "./StatsDealsTab.vue?vue&type=template&id=760ab808&scoped=true&"
import script from "./StatsDealsTab.vue?vue&type=script&lang=js&"
export * from "./StatsDealsTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsDealsTab.vue?vue&type=style&index=0&id=760ab808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ab808",
  null
  
)

export default component.exports